(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("datatable", [], factory);
	else if(typeof exports === 'object')
		exports["datatable"] = factory();
	else
		root["datatable"] = factory();
})(this, function() {
return 